export default __webpack_public_path__ + "static/media/pdfHeaderPhillipine.407462fc.png";